"use client";

import { usePathname } from "next/navigation";

import SchemaContact from "@/components/Schema/SchemaContact";
import SchemaNeurology from "@/components/Schema/SchemaNeurology";
import SchemaNephrology from "@/components/Schema/SchemaNephrology";
import SchemaCtvs from "@/components/Schema/SchemaCtvs";
import SchemaOrthopaedics from "./Schema/SchemaOrthopaedics";
import SchemaRenalTransplant from "./Schema/SchemaRenalTransplant";
import SchemaUrology from "./Schema/SchemaUrology";
import SchemaDialysisCare from "./Schema/SchemaDialysisCare";
import SchemaInterventionalCardiology from "./Schema/SchemaInterventionalCardiology";
import SchemaPediatricNephrology from "./Schema/schemaPediatricNephrology";
import SchemaNeurosurgery from "./Schema/SchemaNeurosurgery";
import SchemaBrainSpineSurgery from "./Schema/SchemaBrainSpineSurgery";
import SchemaGeneralSurgery from "./Schema/SchemaGeneralSurgery";

export default function SchemaWrapper() {
  const pathname = usePathname();

  const schemaMap = {
    "/": <SchemaContact />,
    "/contact": <SchemaContact />,
    "/our-centers-of-excellence/department-of-neuro-science/neurology-care": <SchemaNeurology />,
    "/our-centers-of-excellence/institute-of-renal-science-and-renal-transplant/nephrology-care": <SchemaNephrology />,
    "/our-centers-of-excellence/institute-of-cardiac-sciences/ctvs": <SchemaCtvs />,
    "/our-centers-of-excellence/department-of-orthopaedics": <SchemaOrthopaedics />,
    "/our-centers-of-excellence/institute-of-renal-science-and-renal-transplant/renal-transplant": <SchemaRenalTransplant />,
    "/our-centers-of-excellence/institute-of-renal-science-and-renal-transplant/urology-treatment": <SchemaUrology />,
    "/our-centers-of-excellence/institute-of-renal-science-and-renal-transplant/dialysis-care": <SchemaDialysisCare />,
    "/our-centers-of-excellence/institute-of-cardiac-sciences/interventional-cardiology": <SchemaInterventionalCardiology />,
    "/our-centers-of-excellence/institute-of-renal-science-and-renal-transplant/pediatric-nephrology-care": <SchemaPediatricNephrology />,
    "/our-centers-of-excellence/department-of-neuro-science/neurosurgery-department": <SchemaNeurosurgery />,
    "/our-centers-of-excellence/department-of-neuro-science/spine-department": <SchemaBrainSpineSurgery />,
    "/our-centers-of-excellence/department-of-general-surgery": <SchemaGeneralSurgery />
  };

  return schemaMap[pathname] || null;
}
